export default "__VITE_ASSET__B18IghmE__"